let dev_env = {
  PUBLIC_URL: "https://devproxypublicapis.lavabee.com",
  USER_URL: "https://devproxyuserapis.lavabee.com",

  MORALIS_URL: "https://deep-index.moralis.io",
  MORALIS_API_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjY3OTJmNjVjLTY3ZTgtNDExMC05MmQ2LTVjYzg2MGU0MzE4YSIsIm9yZ0lkIjoiMjcxMzQyIiwidXNlcklkIjoiMjc2MzY5IiwidHlwZUlkIjoiNjlkMTVlZTctZTc3MS00ZmFjLWFiYjYtNWQ2ZmVkMGI0MTNmIiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE2ODQzODQ4NzAsImV4cCI6NDg0MDE0NDg3MH0.n7JXfbFeLTl-Cou-BV_S-TR6voqIn-w-JpcTGfq6P90",
  ETH_CHAIN: "sepolia",
  POLYGON_CHAIN: "amoy",
  PROXY_TOKEN_CONTRACT_ADDRESS: "0x6b1498C6C70E687Ea7c39dD06F81A827495823DE",
  ETH_RPC_URL: "https://ethereum-sepolia.publicnode.com",
  POLYGON_RPC_URL: "https://polygon-amoy.g.alchemy.com/v2/OJtIa5M3OHp1b-G40hHHzqhpJ8vZ94zg",
  NETWORK_VERSION: "80002",
  CHAIN_ID: "0x13882"
};

let uat_env = {
  PUBLIC_URL: "https://uatproxypublicapis.lavabee.com",
  USER_URL: "https://uatproxyuserapis.lavabee.com",
  MORALIS_URL: "https://deep-index.moralis.io",
  MORALIS_API_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjY3OTJmNjVjLTY3ZTgtNDExMC05MmQ2LTVjYzg2MGU0MzE4YSIsIm9yZ0lkIjoiMjcxMzQyIiwidXNlcklkIjoiMjc2MzY5IiwidHlwZUlkIjoiNjlkMTVlZTctZTc3MS00ZmFjLWFiYjYtNWQ2ZmVkMGI0MTNmIiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE2ODQzODQ4NzAsImV4cCI6NDg0MDE0NDg3MH0.n7JXfbFeLTl-Cou-BV_S-TR6voqIn-w-JpcTGfq6P90",
  ETH_CHAIN: "eth",
  POLYGON_CHAIN: "polygon",
  PROXY_TOKEN_CONTRACT_ADDRESS: "0xE57A2EBa7fa1962cBC7b430428A97C287b2Fb8b1",
  // eth mainnet rpc
  ETH_RPC_URL: "https://eth.llamarpc.com",
  POLYGON_RPC_URL: "https://polygon-rpc.com",
  NETWORK_VERSION: "137",
  CHAIN_ID: "0x89"
};

const env = process.env.REACT_APP_ENV === "uat" ? uat_env : dev_env;

export default env;
